import { render } from "./SingleNotifiaction.vue?vue&type=template&id=9c3aa76c&scoped=true"
import script from "./SingleNotifiaction.vue?vue&type=script&lang=js"
export * from "./SingleNotifiaction.vue?vue&type=script&lang=js"

import "./SingleNotifiaction.vue?vue&type=style&index=0&id=9c3aa76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c3aa76c"]])

export default __exports__